import React, { useState, useEffect } from 'react';

import Link from '../../link/link';

import * as styles from './alertBanner.module.scss';

import { AlertArrowLeft, AlertArrowRight } from '../../../assets/svg/index';
import { HeaderBanner } from '../../../models/strapi/stateLandingPageQuery';

interface Props {
    usingMouse: boolean;
    data: HeaderBanner[];
}

const AlertBanner = ({ usingMouse, data }: Props) => {
    const [count, setCount] = useState(0);

    const bannerItems: HeaderBanner[] = [];
    if (data && data.length) {
        data.filter((item) => item.enabled).map((item) => {
            bannerItems.push(item);
        });
    }

    useEffect(() => {
        const counter = setInterval(() => {
            setCount((count) => count + 1);
        }, 8000);

        return () => {
            clearInterval(counter);
        };
    }, []);

    return (
        <>
            {bannerItems.map((item, i) => {
                return count % bannerItems.length === i ? (
                    <div className={styles.alertBanner} id='alert-banner' key={i}>
                        <AlertArrowLeft
                            onClick={() => setCount(count + (bannerItems.length - 1))}
                            className={bannerItems.length === 1 ? styles.hide : ''}
                        />
                        <div className={styles.linkText}>
                            <Link
                                key={i}
                                usingMouse={usingMouse}
                                link={item.url}
                                aria-label={item.text}>
                                {item.text}
                            </Link>
                        </div>
                        <AlertArrowRight
                            onClick={() => setCount(count + 1)}
                            className={bannerItems.length === 1 ? styles.hide : ''}
                        />
                    </div>
                ) : null;
            })}
        </>
    );
};

export default AlertBanner;
